function showReviewForm() {
    $(".review-form-2020 .rating--box").fadeIn();
    $(".button-review a").attr("href", "javascript:hideReviewForm()");
    $(".button-review a").html('Đóng');
    $(".button-review a").addClass("close-btt");
}

function hideReviewForm() {
    $(".review-form-2020 .rating--box").fadeOut();
    $(".button-review a").attr("href", "javascript:showReviewForm()");
    $(".button-review a").html('Gửi đánh giá của bạn');
    $(".button-review a").removeClass("close-btt");
}

$(document).ready(function () {
    $('.rating-star').hover(
        function () {
            $(this).addClass('hover');
            //console.log($(this).attr('data-title'))
            $('#star_tip').html($(this).attr('data-title'));
        },
        function () {
            $(this).removeClass('hover');
            $('#star_tip').html($('.rating-comment input:checked').attr('data-title'));

        }
    );
});
